/**
 * Arama yapılabilir font seçici - Google Fonts ile senkron
 */
import { useState, useRef, useEffect } from 'react';

const FontSelect = ({ value, onChange, options = [], disabled, placeholder = 'Font seçin...', className = '' }) => {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState('');
    const containerRef = useRef(null);

    const filtered = search.trim()
        ? options.filter(f => f.name.toLowerCase().includes(search.toLowerCase().trim()))
        : options;

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const displayValue = value || placeholder;
    const selectedFont = options.find(f => f.name === value);

    return (
        <div ref={containerRef} className={`relative ${className}`}>
            <button
                type="button"
                disabled={disabled}
                onClick={() => !disabled && setOpen(o => !o)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm text-left focus:ring-orange-500 focus:border-orange-500 disabled:bg-gray-100 disabled:cursor-not-allowed flex items-center justify-between"
                style={{ fontFamily: selectedFont ? `"${selectedFont.name}", sans-serif` : 'inherit' }}
            >
                <span>{displayValue}</span>
                <svg className={`w-4 h-4 text-gray-500 transition ${open ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
            </button>

            {open && (
                <div className="absolute z-50 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-72 flex flex-col">
                    <div className="p-2 border-b border-gray-100 sticky top-0 bg-white rounded-t-lg">
                        <input
                            type="text"
                            placeholder="Font ara..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-200 rounded-md text-sm focus:ring-orange-500 focus:border-orange-500"
                            autoFocus
                        />
                    </div>
                    <div className="overflow-y-auto flex-1 min-h-0 py-1">
                        {filtered.length === 0 ? (
                            <div className="px-3 py-4 text-sm text-gray-500 text-center">Sonuç bulunamadı</div>
                        ) : (
                            filtered.map(font => (
                                <button
                                    key={font.name}
                                    type="button"
                                    onClick={() => {
                                        onChange(font.name);
                                        setOpen(false);
                                        setSearch('');
                                    }}
                                    className={`w-full px-3 py-2 text-left text-sm hover:bg-orange-50 flex items-center justify-between ${value === font.name ? 'bg-orange-50 text-orange-700' : 'text-gray-700'}`}
                                    style={{ fontFamily: `"${font.name}", sans-serif` }}
                                >
                                    <span>{font.name}</span>
                                    <span className="text-xs text-gray-400">{font.category}</span>
                                </button>
                            ))
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default FontSelect;
